module.exports = __webpack_public_path__ + "img/info-book.39d9c019.svg";